import React, { useContext } from 'react';
import {
  Box, Checkbox, FormControlLabel, FormGroup,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import DigitalSectionToolbar from '../../digitalTrial/DigitalSectionToolbar';
import { DigitalSection } from '../../../redux/types';
import SurveyOptionContext from '../../../views/admin/SurveyOptionContext';
import useUpdateGtAndMaxScores from '../../../hooks/groundTruth/useUpdateGtAndMaxScores';

type Props = {
  sections?: DigitalSection[];
  selectedSection?: DigitalSection;
  setSelectedSection: (sectionId?: number | undefined) => void;
  updateDigitalSection: (section: DigitalSection) => void;
};

const SectionSettings: React.FC<Props> = ({
  sections,
  selectedSection,
  setSelectedSection,
  updateDigitalSection,
}: Props) => {
  const { disableEdit } = useContext(SurveyOptionContext);
  const { recalculateMaxSurveyScoreOnOptionalChange } = useUpdateGtAndMaxScores();

  const handleOptionalSectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (selectedSection) {
      updateDigitalSection({ ...selectedSection, optional: checked });
      // if the section is optional, we need to remove the section passing score from survey scores
      recalculateMaxSurveyScoreOnOptionalChange({ ...selectedSection, optional: checked });
    }
  };

  const handleOptOutChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (selectedSection) {
      updateDigitalSection({ ...selectedSection, canOptOut: checked });
    }
  };

  return (
    <Box display="flex" gap={2} alignItems="center">
      <Box flexGrow={0.5} aria-label="section-editor" sx={{ my: 2, py: 3 }}>
        <DigitalSectionToolbar
          digitalSections={sections}
          selectedSection={selectedSection}
          setSelectedSection={setSelectedSection}
          labelText="Section"
        />
      </Box>
      <Box>
        <FormGroup>
          <FormControlLabel
            control={(
              <Checkbox
                checked={!!selectedSection?.canOptOut}
                onChange={handleOptOutChange}
                disabled={disableEdit}
              />
            )}
            label={<FormattedMessage id="sectionSettings.optOut" />}
          />
          <FormControlLabel
            control={(
              <Checkbox
                checked={!!selectedSection?.optional}
                onChange={handleOptionalSectionChange}
                disabled={disableEdit}
              />
            )}
            label={<FormattedMessage id="sectionSettings.optionalSection" />}
          />
        </FormGroup>
      </Box>
    </Box>
  );
};

export default SectionSettings;
